var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-btn',{staticClass:"mt-4 text-decoration-none",attrs:{"block":"","large":"","outlined":"","target":"_blank","href":_vm.url}},[_c('v-icon',{attrs:{"left":""}},[_vm._v(" mdi-plus ")]),_vm._v(" Google Calendar ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }